import { createContext } from 'react';
import { klona } from 'klona';
import { storagePrefixV2 } from '@/constant';

export const DIMENTION_2_TEXT: Record<keyof GetLastMeasurementResponse, string> = {
  backThickness: '背厚围度',
  leftArmCircumference: '左臂围度',
  rightArmCircumference: '右臂围度',
  waistCircumference: '腰部围度',
  leftThighCircumference: '左大腿围度',
  rightThighCircumference: '右大腿围度',
  leftCalfCircumference: '左小腿围度',
  rightCalfCircumference: '右小腿围度',
};

export const MODEL_CARD_CONFIG: Array<{
  name: keyof GetLastMeasurementResponse;
  [key: string]: any;
}> = [
  {
    name: 'backThickness',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '52%',
      top: '21%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/asdasdafas-min.png)`,
      width: '170px',
      height: '75px',
      left: '53%',
      top: '11%',
    },
    valueContentConfig: {
      left: '64%',
      top: '11%',
    },
  },
  {
    name: 'leftArmCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '42.5%',
      top: '29%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/baaasdasq-min.png)`,
      width: '126px',
      height: '126px',
      left: '32.3%',
      top: '10%',
    },
    valueContentConfig: {
      right: '63.3%',
      top: '10%',
    },
  },
  {
    name: 'rightArmCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '56.6%',
      top: '29%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/cqdqwdqwdaqqwrqw.png)`,
      width: '123px',
      height: '72px',
      left: '57%',
      top: '26%',
    },
    valueContentConfig: {
      left: '64%',
      top: '26%',
    },
  },
  {
    name: 'waistCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '46%',
      top: '42%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/daqwdwdqw.png)`,
      width: '166px',
      height: '96px',
      left: '32.3%',
      top: '28%',
    },
    valueContentConfig: {
      right: '63.3%',
      top: '28%',
    },
  },
  {
    name: 'leftThighCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '44%',
      top: '63.5%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/eadoqfdqwf.png)`,
      width: '147px',
      height: '92px',
      left: '32.3%',
      top: '51%',
    },
    valueContentConfig: {
      right: '63.3%',
      top: '51%',
    },
  },
  {
    name: 'rightThighCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '55%',
      top: '63.5%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/ffdgwqwq.png)`,
      width: '146px',
      height: '76px',
      left: '56%',
      top: '53.5%',
    },
    valueContentConfig: {
      left: '64%',
      top: '53.5%',
    },
  },
  {
    name: 'leftCalfCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '45%',
      top: '87%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/goisanmgsdf.png)`,
      width: '159px',
      height: '122px',
      left: '32.3%',
      top: '70.5%',
    },
    valueContentConfig: {
      right: '63.3%',
      top: '70.5%',
    },
  },
  {
    name: 'rightCalfCircumference',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '53.7%',
      top: '87%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/3d-body-compare/huasfasfqw.png)`,
      width: '158px',
      height: '123px',
      left: '53.4%',
      top: '70.5%',
    },
    valueContentConfig: {
      left: '64%',
      top: '70.5%',
    },
  },
];

export const BODYPAIN_CARD_2_TEXT: Record<'shoulder' | 'waist', string> = {
  shoulder: '肩部疼痛程度',
  waist: '腰部疼痛程度',
};

export const BODYPAIN_CARD_CONFIG = [
  {
    name: 'shoulder',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '50.7%',
      top: '28.5%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/ai-consulation/zzzzzaasdsadf-min.png)`,
      width: '170px',
      height: '75px',
      left: '52%',
      top: '18.5%',
    },
    valueContentConfig: {
      left: '61.2%',
      top: '18.5%',
    },
  },
  {
    name: 'waist',
    dotConfig: {
      '--inner-circle-color': '#00B87A',
      left: '45%',
      top: '60%',
    },
    connectionLineConfig: {
      background: `url(${storagePrefixV2}/ai-consulation/zzkakasa-min.png)`,
      width: '172px',
      height: '124px',
      left: '31%',
      top: '43%',
    },
    valueContentConfig: {
      right: '64.5%',
      top: '43%',
    },
  },
];

export const PAIN_RELIEF_2_TEXT: Record<GetBodyChangeResponse['painReliefHopes'][0] | 'back', string> = {
  camelBack: '驼背',
  headTilt: '头前倾',
  highLowBack: '高低背',
  richBag: '富贵包',
  roundShoulderBack: '圆肩背',
  shoulder: '肩部',
  waist: '腰部',
  back: '背部',
};

interface TBodyChange3DContext {
  bodyChangeInfo: GetBodyChangeResponse;
  weightLossDescText: string;
  bodyAdjustDescText: string;
}

export const BodyChange3DContext = createContext<TBodyChange3DContext>({
  bodyChangeInfo: {} as GetBodyChangeResponse,
  weightLossDescText: '',
  bodyAdjustDescText: '',
});

export const PAIN_LEVEL_2_PLAIN_TEXT = {
  0: '察觉不到',
  1: '刚刚注意到',
  2: '轻度疼痛',
  3: '中度疼痛',
  4: '重度疼痛',
  5: '剧烈疼痛',
};

export const formatHopesText = (painReliefHopes: GetBodyChangeResponse['painReliefHopes']) => {
  if (!painReliefHopes?.length) return;

  const ALL_PART = ['shoulder', 'back', 'waist'];

  let showText = '';

  const classifyHopes = painReliefHopes?.reduce(
    (accur, item) => {
      if (ALL_PART.includes(item)) {
        accur['part']?.push(item);
      } else {
        accur['rest']?.push(item);
      }
      return accur;
    },
    {
      part: [],
      rest: [],
    }
  );

  if (classifyHopes?.part?.length) {
    showText +=
      '减轻' +
      klona(classifyHopes?.part)
        ?.sort((a, b) => ALL_PART.indexOf(a) - ALL_PART.indexOf(b))
        ?.map(item => PAIN_RELIEF_2_TEXT[item])
        ?.join('、') +
      '疼痛';
  }

  if (classifyHopes?.rest?.length) {
    showText +=
      (classifyHopes?.part?.length ? '，' : '') +
      '改善' +
      classifyHopes?.rest?.map(item => PAIN_RELIEF_2_TEXT[item])?.join('、');
  }

  return showText;
};

export const BodyAdjustOperateTexts = ['深层痛点精准粉碎~', '松解粘连肌肉筋膜，关节自如舒展'];
export const WeightLossOperateTexts = ['在持续变美的路上啦~', '软化顽固脂肪，体态更轻盈啦~'];
